import { render } from "./CookiesSortingTH.vue?vue&type=template&id=3a086054&scoped=true&ts=true"
import script from "./CookiesSortingTH.vue?vue&type=script&lang=ts"
export * from "./CookiesSortingTH.vue?vue&type=script&lang=ts"

import "./CookiesSortingTH.vue?vue&type=style&index=0&id=3a086054&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a086054"]])

export default __exports__